// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2_w3T","noInteraction":"EventWrapper_noInteraction__1Sm_D","pointerPassthrough":"EventWrapper_pointerPassthrough__2PbqZ"};